export const SPACE_NODE_WIDTH = 290;
export const SPACE_NODE_TEST_ID = "space-node";
